export const pageTitle = {
  'Tracker Settings': '追跡設定',
  'Marketing & Tracker': 'オンラインストアのマーケティングと追跡',
  'Add Event Tracker': '新追跡ツール',
  'Add Event Tracker_edit': '追跡ツールの編集',
  Apps: '拡張機能',
  'Apps Store': '拡張機能ストア',
};
